import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CartService } from '../../services/cart.service';
import { DownloadModalService } from '../../services/download-modal.service';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';

const BASE_URL = environment.apiUrl;

@Component({
  selector: 'app-template-preview',
  templateUrl: './template-preview.component.html',
  styleUrls: ['./template-preview.component.css']
})
export class TemplatePreviewComponent implements OnInit, OnDestroy {
  selectedProduct: any = null;
  cartCount = 0;
  inCart = false;
  private sub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cartService: CartService,
    private downloadModal: DownloadModalService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.apiService.getTemplatePreview(id).subscribe({
        next: (res) => {
          if (res.status && res.data) {
            const t = res.data;
            this.selectedProduct = { ...t,title: t.name, image: `${BASE_URL}/uploads/template_images/${t.template_image}`, description: t.description };
            this.checkInCart();
          }
        },
        error: (err) => {
          console.error('Error fetching template preview:', err);
        }
      });
    }

    this.sub = this.cartService.items$.subscribe(items => {
      this.cartCount = items.length;
      this.checkInCart();
    });
  }

  private checkInCart() {
    if (this.selectedProduct) {
      this.inCart = this.cartService.has(this.selectedProduct.id);
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  toggleCart(): void {
    if (!this.selectedProduct) return;
    if (this.inCart) {
      this.cartService.remove(this.selectedProduct.id);
    } else {
      this.cartService.add({
        id: this.selectedProduct.id,
        title: this.selectedProduct.title,
        image: this.selectedProduct.image,
        description: this.selectedProduct.description,
        price: this.selectedProduct.price
      });
    }
  }

  openDownload(): void {
    this.downloadModal.open(this.selectedProduct ? { template_id: this.selectedProduct.id } : null);
  }

  goToCart(): void {
    this.router.navigate(['/cart']);
  }
}


